import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useMainContext } from '@contexts/Contexts';
import { getTalkById } from '@utils/TalksUtils';
import Loader from '@components/Misc/Loader';
import Podium from '@components/Icons/podium.svg';
import Location from '@components/Icons/location.svg';
import Tag from '@components/Icons/tag.svg';
import Left from '@components/Icons/left.svg';
import SupporterList from './components/SupporterList/supporter-list';
import SpeakerList from './components/SpeakerList/speaker-list';
import AddToCalButton from '@components/AddToCalendar/add-to-calendar';
import ExternalLink from './components/ExternalLink';

const SingleTalk = () => {
	const { selectedTalkId } = useMainContext().state;
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [talk, setTalk] = useState([]);

	useEffect(() => {
		if (selectedTalkId) {
			const getTalk = async () => {
				const talkData = await getTalkById(
					setLoading,
					setError,
					selectedTalkId,
				);
				setTalk(talkData);
			};
			getTalk();
		}
	}, [selectedTalkId]);

	/*Bail out early*/
	if (loading) {
		return (
			<div className="cfs-talk-list-loader-wrapper">
				<Loader />
			</div>
		);
	}

	if (error) {
		return <p>Error talk: {error.message}</p>;
	}

	const {
		title = '',
		taxonomies: { days = [], venues = [], tags = [], categories = [] },
		sponsors = [],
		time_start = '',
		time_end = '',
		timezone_text = '',
		content = '',
		speakers = [],
		custom_venue: CustomVenue = '',
	} = talk;

	const NavigateButton = () => {
		return (
			<div className="cfs-navigate-back">
				<Link to="/" className="cfs-navigate-back__link">
					<img
						className="cfs-talk-ui-icon"
						src={Left}
						alt="Eye icon"
						width="16"
						height="16"
					/>
					<span>BACK TO FULL AGENDA</span>
				</Link>
			</div>
		);
	};

	return (
		<div className="cfs-talk-wrapper">
			<NavigateButton />
			<div className="cfs-single-talk">
				<h1 className="cfs-single-talk-title">{title}</h1>
				<div className="cfs-single-meta-wrapper">
					<div className="cfs-single-meta">
						{days &&
							days.map((day, index) => (
								<span
									key={index}
									className="cfs-single-meta-day"
								>
									{day.name}
								</span>
							))}
						{time_start && (
							<span className="cfs-single-meta-time-start">
								{time_start}
							</span>
						)}
						{time_end && (
							<span className="cfs-single-meta-time-end">
								{time_end}
							</span>
						)}
						{timezone_text && (
							<span className="cfs-single-meta-timezone">
								({timezone_text})
							</span>
						)}
						<div className="cfs-single-talk-taxonomies">
							{(venues || CustomVenue) && (
								<div className="cfs-single-talk-taxonomies__venues">
									<img
										className="cfs-talk-ui-icon"
										src={Location}
										alt="Location icon"
									/>{' '}
									{!CustomVenue &&
										venues.map((venue, index) => (
											<div
												className="venue-item"
												key={index}
											>
												<span className="venue-name">
													{venue.name}
												</span>
												{venue.location && (
													<span className="venue-location">
														{venue.location}
													</span>
												)}
											</div>
										))}
									{CustomVenue && <span>{CustomVenue}</span>}
								</div>
							)}
							{categories && (
								<div className="cfs-single-talk-taxonomies__categories">
									<img
										className="cfs-talk-ui-icon"
										src={Podium}
										alt="Podium icon"
									/>{' '}
									{categories.map((category, index) => (
										<div
											className="category-item"
											key={index}
										>
											{category.name}
										</div>
									))}
								</div>
							)}
							{tags && (
								<div className="cfs-single-talk-taxonomies__tags">
									<img
										className="cfs-talk-ui-icon"
										src={Tag}
										alt="Hashtag icon"
									/>{' '}
									{tags.map((tag, index) => (
										<div className="tag-item" key={index}>
											{tag.name}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
					<div className="cfs-single-meta-add-to-calendar">
						<AddToCalButton
							data={talk}
							customDays={talk.taxonomies?.days}
						/>
					</div>
				</div>
				<div className="cfs-single-content-wrapper">
					<div className="cfs-single-content">
						{content && (
							<>
								<h3 className="cfs-single-section-title">
									Description
								</h3>
								<div
									dangerouslySetInnerHTML={{
										__html: content,
									}}
								/>
							</>
						)}
						<ExternalLink data={talk} />
					</div>
					{sponsors.length > 0 && (
						<div className="cfs-single-content-supporters">
							<h3 className="cfs-single-section-title">
								Partner
							</h3>
							<SupporterList data={sponsors} />
						</div>
					)}
				</div>
				{speakers && speakers.length !== 0 && (
					<div className="cfs-single-content-speakers-wrapper">
						<h3 className="cfs-single-section-title">Speakers</h3>
						<SpeakerList data={speakers} />
					</div>
				)}
			</div>

			<br />
			<NavigateButton />
		</div>
	);
};
export default SingleTalk;
